import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap"; 

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { apiUrl, carImageUrl} from'../Config/Config';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import moment from 'moment';

class List extends Component {
  
  constructor(props)
  {
    super(props);
    this.state = {
      referencelist:'',
      domainlist:[],
      confirmDelete:null,
      totalRecord:0,
      referencelist:[],
    };
    this.deleteConfirm = this.deleteConfirm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    

    componentDidMount() {
      var qs = require('qs');
      var admin_id = localStorage.getItem("admin_id");
      var loggedas = localStorage.getItem("loggedas");
      var postobject = {
      activePage: 1,
      search_all: '',
      admin_id: admin_id,
      loggedas: loggedas
      };  

      axios.post(apiUrl+"reference/list",qs.stringify(postobject)).then(res => {
        if(res.data.status === 'success'){
         
            this.setState({  referencelist: res.data.referencelist, totalRecord: res.data.records_count}, function() {
            
              this.referencelist();
            });
  
        }
      }); 
   }

   handlePageChange(pageNumber) {
    // console.log(`active page is ${pageNumber}`);
     this.setState({activePage: pageNumber});

     var qs = require('qs');

     var admin_id = localStorage.getItem("admin_id");
     var loggedas = localStorage.getItem("loggedas");
     var postobject = {
       activePage: pageNumber,
       search_all: this.state.search_all,
       admin_id: admin_id,
       loggedas:loggedas
     };
    //  this.props.getreferencelist(qs.stringify(postobject))
    axios.post(apiUrl+"reference/list",qs.stringify(postobject)).then(res => {
      
      if(res.data.status === 'success'){
          this.setState({  referencelist: res.data.referencelist, totalRecord: res.data.records_count}, function() {
            this.referencelist();
          });

      }
    }); 

   }

   handleInputChange(event) {
   const {name, value} = event.target;      
   this.setState({
     [name]: value
   },()=>{
    this.handleFormSubmit();
   });
   
 }

 handleFormSubmit = () => {
        
  this.setState({Loading:true});
  var qs = require('qs');
  const formPayload = this.state;
   var admin_id = localStorage.getItem("admin_id");
   var loggedas = localStorage.getItem("loggedas");
  var postObject = {             
    activePage   : 1,
    search_all : formPayload.search_all,
    admin_id: admin_id,
    loggedas: loggedas         
  };
  axios.post(apiUrl+"reference/list",qs.stringify(postObject)).then(res => {
    if(res.data.status === 'success'){

        this.setState({  referencelist: res.data.referencelist, totalRecord: res.data.records_count}, function() {
          this.referencelist();
        });

    }else{
      this.setState({  referencelist: '', totalRecord: 0}, function() {
        this.referencelist();
      });
    }
  }); 

} 



   componentWillReceiveProps(Props){

     if (Props.deletereference!== this.props.deletereference) {
      if (Props.deletereference[0]["status"] === "success") {
         
          $('.success_message').html('<div class="status_sucess"><h3>'+ Props.deletereference[0]["message"]+'</h3></div>');
           var qs = require('qs');
              var admin_id = localStorage.getItem("admin_id");
              var postobject = {
              activePage: 1,
              search_all: '',
              admin_id: admin_id
              };

              // this.props.getreferencelist(qs.stringify(postobject));
              axios.post(apiUrl+"reference/list",qs.stringify(postobject)).then(res => {
                if(res.data.status === 'success'){
           
                    this.setState({  referencelist: res.data.referencelist, totalRecord: res.data.records_count}, function() {
                      this.referencelist();
                    });
          
                }
              }); 
           setTimeout(
          function() {
          $('.success_message').html('');
          //window.location.reload(); 
          }
          .bind(this),
          3000
          );


          this.setState({referencelist: Props.deletereference[0]["referencelist"]}, function() {
            this.referencelist();
          });       
          }
          
      }

       if(Props.referenceactive !== this.props.referenceactive){
      if (Props.referenceactive[0]["status"] === "success") {

        $('.success_message').html('<div class="status_sucess"><h3>'+ Props.referenceactive[0]["message"]+'</h3></div>');
              var qs = require('qs');
              var admin_id = localStorage.getItem("admin_id");
              var postobject = {
              activePage: 1,
              search_all: '',
              admin_id: admin_id
              };

              // this.props.getreferencelist(qs.stringify(postobject));
               axios.post(apiUrl+"reference/list",qs.stringify(postobject)).then(res => {
    if(res.data.status === 'success'){

        this.setState({  referencelist: res.data.referencelist, totalRecord: res.data.records_count}, function() {
          this.referencelist();
        });

    }
  }); 


           
           setTimeout(
          function() {
          $('.success_message').html('');
          //window.location.reload(); 
          }
          .bind(this),
          3000
          );

      }
    }
     
   }

//    deletereference(id){
//     var qs = require('qs');
//     var postObject = {
//       admin_id : localStorage.getItem("admin_id"),
//       id  :id
//     };

//   axios.post(apiUrl+"reference/delete",qs.stringify(postObject)).then(res => {
//     if(res.data.status === 'success'){       
//           window.location.reload(); 
//     }
//   }); 
// }
deleteConfirm=(confirmstatus,id)=>{
  if(confirmstatus == 'yes'){
    $('.confirm-action-delete').removeClass('show');
    var qs = require('qs');
      var postObject = {
        admin_id : localStorage.getItem("admin_id"),
        id  :id
      };

    axios.post(apiUrl+"reference/delete",qs.stringify(postObject)).then(res => {
      if(res.data.status === 'success'){       
            window.location.reload(); 
      }
    });
  }else{
    $('.confirm-action-delete').removeClass('show');	
  }
}  
deletereference(id){
  this.setState({confirmDelete : id})
  $('.confirm-action-delete-message').html('Are you sure delete the technician?');	
  $('.confirm-action-delete').addClass('show');	
 }
activatereference(id, status){
  let stat = ''
    if(status == 'Inactive'){
      stat = "A";
    }else{
      stat = "I";
    }
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :id,
          status: stat
        };

      // this.props.getActivatereference(qs.stringify(postObject));
      axios.post(apiUrl+"reference/change_status",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){
          window.location.reload(false);
        }
      }); 
}


referencelist() {
  let catImg = '';
  let preview = '';
    var referencelist = this.state.referencelist;
    if (referencelist != "undefined" && referencelist != null) {
     
    
      if (referencelist.length > 0) {

        if (Object.keys(referencelist).length > 0) {
          const helperlistDetails = referencelist.map(
            (referencelist, Index) => {
              let sno = Index+1;
              

              // var istyle = { width: 200};
              return (
                <tr key={referencelist.id}>
                    <td>{sno}</td>
                    <td>{referencelist.joinuser}</td>
                    <td>{referencelist.refereruser}</td>
                    <td>{referencelist.refered_type}</td>
                    <td>{moment(referencelist.created_on).format("MM-DD-Y H:m A")}</td>
                    <td>{referencelist.discount}</td>
                    <td>{referencelist.refererlocation}</td>

                    <td>
                        <Link to={{ pathname:'/referaluser-view/'+referencelist.id}} className="" title="View">  <i className="fa fa-eye" aria-hidden="true"></i>
                        </Link>
                    </td>
                </tr>
              );
            }
          );
          return helperlistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="11" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }else {
      return (
        <tr>
          <td colspan="11" className="v-align-nr">
            No Result
          </td>
        </tr>
      );
    }
  }
  


  render() {
   
    const {domainlist,universitynamelist} = this.state;
	  var current = this;
    var admin_id = localStorage.getItem('admin_id');
   let catImg = '';
  let preview = '';
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="reference" /> 
      <div className="content"> 
        <div className="content-wrapper">
        <div class="content-wrapper-before"></div>
   
         <div className="car-listing-wrap leaa-admin-head card vi-2">
            <div className="success_message"></div>
              <div className="listing-header">
                <div className="title">
                  <h3>{this.state.referencelist.length>0&&this.state.referencelist.length} Invited Users</h3>
                </div>
                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                 {/* <div className="add_button">  
                    <a className="" href='/reference-add'>Add</a>
                </div> */}
                </div>      
                         
              <div style={{color:"green", fontSize: 30}} className="statusmessage"></div>
            
              <div className="car-listing-row table-avrech">
              <div className="overflow">
                <Table striped bordered hover>
                  <thead>
                  <tr>
                  <th>S.No</th>
			            <th>Joined user</th>
                  <th>Referred by</th>
                  <th>Invited via</th>
                  <th>Joining date</th>
                  <th>Discount</th>
                  <th>Location</th>
                  <th style={{width:"100px"}}>Action</th>
                   </tr>
                  </thead>
                  <tbody>{this.referencelist()}</tbody>
                </Table>
			        	</div>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      <div className="confirm-action-delete">
								<p className="confirm-action-delete-message"></p>
								<a href="javascript://" onClick={this.deleteConfirm.bind(this, "yes",this.state.userid)} className="btn">Yes</a>
								<a href="javascript://" onClick={this.deleteConfirm.bind(this, "No")} className="btn">No</a>
								<span class="close-support" onClick={this.deleteConfirm.bind(this, "No")}  >X</span>
				</div>
    </div>
    );
  }
}
export default (withRouter(List));